import { h as __h } from "preact";
/** @import { enterpriseAPIKeyResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ enterpriseId: string }} props
 * @param {enterpriseAPIKeyResponse} apiKey
 */
export const deleteApiKey = async ({
  enterpriseId
}, apiKey) => {
  if (!apiKey.is_expired) {
    const res = await confirmModal({
      title: `Delete '${apiKey.name}'?`,
      action: "Delete",
      body: [" ", __h("p", {}, "The key will stop working immediately and be removed from this list."), " "]
    });
    if (!res) return;
  }
  try {
    await authedApiRequest("DELETE", `/v2/enterprises/${enterpriseId}/api-keys/${apiKey.id}`);
    Query.invalidate([`/v2/enterprises/${enterpriseId}/api-keys`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};